export default "__VITE_ASSET__BxewpsNU__"